import { usePermissions } from "@/features/auth/hooks/usePermission";
import { useMemo } from "react";

export const useHasDepositPermissions = () => {
  const permissions = usePermissions();

  return useMemo(
    () =>
      Object.entries(permissions).some(
        ([key, value]) => key.includes("deposit") && value === "GRANTED",
      ),
    [permissions],
  );
};
